export const fetchPrices = async (productIds: number[], coupons: string[] = []): Promise<{ [key: string]: any }> => {
  const couponsString = coupons.join(',');
  const productIdsString = productIds.join(',');
  const url = `/paddle-prices?coupons=${couponsString}&product_ids=${productIdsString}`;
  const response = await fetch(url, { credentials: 'include' });
  return response.json();
};
